import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus } from "@phosphor-icons/react";
import api from "@/lib/api";
import { OWNER } from "@/constants/testIds";

export default function PurchasesTab() {
  const [rows, setRows] = useState([]);
  const [creators, setCreators] = useState([]);
  const [show, setShow] = useState(false);
  const [form, setForm] = useState({ creator_id: "", transaction_id: "", amount: "", currency: "USD", discord_id: "", kind: "payment", note: "" });

  async function load() {
    const [p, c] = await Promise.all([api.get("/purchases"), api.get("/creators")]);
    setRows(p.data); setCreators(c.data);
  }
  useEffect(() => { load(); }, []);

  async function submit(e) {
    e.preventDefault();
    try {
      await api.post("/purchases", { ...form, amount: parseFloat(form.amount) });
      toast.success("Purchase recorded");
      setShow(false);
      setForm({ creator_id: "", transaction_id: "", amount: "", currency: "USD", discord_id: "", kind: "payment", note: "" });
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed");
    }
  }

  const nameByCreator = Object.fromEntries(creators.map(c => [c.id, `${c.display_name} @${c.slug}`]));

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h2 className="display-heading font-black text-3xl">Purchases</h2>
          <div className="kbd-label text-white/40 mt-1">TEBEX EVENTS + MANUAL ENTRIES</div>
        </div>
        <button onClick={() => setShow(!show)} data-testid={OWNER.addPurchaseBtn} className="neon-btn px-4 py-2 inline-flex items-center gap-2 kbd-label">
          <Plus size={14} weight="bold" /> ADD MANUAL
        </button>
      </div>

      {show && (
        <form onSubmit={submit} className="card-tactical p-6 grid md:grid-cols-6 gap-3">
          <select required value={form.creator_id} onChange={(e) => setForm({ ...form, creator_id: e.target.value })} data-testid={OWNER.addPurchaseCreator} className="bg-black/60 border border-white/10 px-3 py-2 font-mono text-sm md:col-span-2 focus:border-neon-cyan outline-none">
            <option value="">Creator…</option>
            {creators.map(c => <option key={c.id} value={c.id}>{c.display_name}</option>)}
          </select>
          <input required placeholder="tx id" value={form.transaction_id} onChange={(e) => setForm({ ...form, transaction_id: e.target.value })} data-testid={OWNER.addPurchaseTx} className="bg-black/60 border border-white/10 px-3 py-2 font-mono text-sm focus:border-neon-cyan outline-none" />
          <input required type="number" step="0.01" placeholder="amount" value={form.amount} onChange={(e) => setForm({ ...form, amount: e.target.value })} data-testid={OWNER.addPurchaseAmount} className="bg-black/60 border border-white/10 px-3 py-2 font-mono text-sm focus:border-neon-cyan outline-none" />
          <input placeholder="discord_id" value={form.discord_id} onChange={(e) => setForm({ ...form, discord_id: e.target.value })} data-testid={OWNER.addPurchaseDiscord} className="bg-black/60 border border-white/10 px-3 py-2 font-mono text-sm focus:border-neon-cyan outline-none" />
          <select value={form.kind} onChange={(e) => setForm({ ...form, kind: e.target.value })} data-testid={OWNER.addPurchaseKind} className="bg-black/60 border border-white/10 px-3 py-2 font-mono text-sm focus:border-neon-cyan outline-none">
            <option value="payment">payment</option>
            <option value="refund">refund</option>
            <option value="chargeback">chargeback</option>
          </select>
          <button type="submit" data-testid={OWNER.addPurchaseSubmit} className="neon-btn px-4 py-2 kbd-label md:col-span-6">RECORD</button>
        </form>
      )}

      <div className="card-tactical overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="kbd-label text-left text-white/50 border-b border-white/10">
              <th className="px-6 py-3">TX</th><th>CREATOR</th><th>KIND</th><th>AMOUNT</th><th>DISCORD</th><th>SOURCE</th><th>WHEN</th>
            </tr>
          </thead>
          <tbody className="font-mono">
            {rows.map(p => (
              <tr key={p.transaction_id} className="border-b border-white/5">
                <td className="px-6 py-3 truncate max-w-[180px]">{p.transaction_id}</td>
                <td className="font-sans">{nameByCreator[p.creator_id] || p.creator_id}</td>
                <td className={p.kind === "payment" ? "text-emerald-400" : "text-red-400"}>{p.kind}</td>
                <td>${p.amount} {p.currency}</td>
                <td className="text-white/60">{p.discord_id || "—"}</td>
                <td className="text-neon-cyan">{p.source}</td>
                <td className="text-white/50 text-xs">{p.created_at?.slice(0, 19).replace("T", " ")}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={7} className="px-6 py-6 text-white/40">No purchases yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
